export default function() {
    let wrongArgument;
    for (let i = 0; i < arguments.length; i++) {
        //NB! IE demands to iterate like that!
        let arg = arguments[i];
        if (arg.constructor !== Map) {
            wrongArgument = true;
            break;
        }
    }
    if (!wrongArgument) {
        for (let j = 1; j < arguments.length; j++) {
            //NB! IE demands to iterate like that!
            let argument = arguments[j];
            for (let i of argument) {
                const key = i[0];
                const value = i[1];
                arguments[0].set(key, value);
            }
        }
    }
    return arguments[0];
}
